import { z } from 'zod';

/**
 * Marca temporal ISO-8601 en UTC (p. ej. `2026-09-17T14:03:00.000Z`).
 * Equivale a `z.string().datetime()` de Zod 3; en Zod 4 la forma canónica es `z.iso.datetime()`.
 * El cliente formatea en la zona de la empresa/sede (contracts/admin-api.md).
 */
export const IsoDateTimeSchema = z.iso.datetime({ message: 'Fecha y hora ISO-8601 UTC inválida' });
export type IsoDateTime = z.infer<typeof IsoDateTimeSchema>;

/** Variante nullable, para columnas como `suspended_at`, `deactivated_at`, `last_login_at`. */
export const NullableIsoDateTimeSchema = IsoDateTimeSchema.nullable();

/** Fecha local de la sede, `YYYY-MM-DD`. */
export const LocalDateSchema = z.iso.date();
export type LocalDate = z.infer<typeof LocalDateSchema>;

/** Hora local de la sede, `HH:mm` en 24 h. La API la convierte con la zona vigente de la sede. */
export const LocalTimeSchema = z
  .string()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/, { message: 'Hora inválida: usa HH:mm en 24 horas' });
export type LocalTime = z.infer<typeof LocalTimeSchema>;
